import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import SupervisorTotalContainer from 'flow/components/pbx/supervisor/sub-components/SupervisorTotalContainer';
import { selectNumberOfWaitingQueueItems } from 'flow/selectors/call-selectors';

import { selectSelectedQueues } from '../Overview/SupervisorOverviewSelectors';

const NumberOfItemsInQueuesContainer = () => {
    const selectedQueues = useAppSelector(selectSelectedQueues);

    const numberOfItems = useAppSelector((state) =>
        selectNumberOfWaitingQueueItems(state, selectedQueues),
    );
    return (
        <SupervisorTotalContainer
            colorType={'yellow'}
            iconType={'phone'}
            label={numberOfItems}
        />
    );
};

export default React.memo(NumberOfItemsInQueuesContainer);
